import {
  CheckIcon,
  MinusCircleIcon,
  ProhibitIcon,
  QuestionMarkIcon,
  ShieldCheckIcon,
  ShieldWarningIcon,
  WarningCircleIcon,
  WarningIcon,
  XIcon,
} from '@phosphor-icons/react'
import { match } from 'ts-pattern'
import z from 'zod'
import * as styles from './outcome-icon.css.ts'
import { type OutcomeType } from './outcome-types.ts'

export const OutcomeIconSizeSchema = z.enum(['small', 'default'])
export type OutcomeIconSize = z.infer<typeof OutcomeIconSizeSchema>

export type OutcomeIconProps = {
  outcomeType: OutcomeType
  size: OutcomeIconSize
}

export const OutcomeIcon: React.FC<OutcomeIconProps> = ({ outcomeType, size }) => {
  const Icon = match(outcomeType)
    .with('true-positive', () => WarningCircleIcon)
    .with('likely-true-positive', () => WarningIcon)
    .with('inconclusive', () => QuestionMarkIcon)
    .with('potentially-exploitable', () => QuestionMarkIcon)
    .with('no-fix-necessary', () => CheckIcon)
    .with('no-fix-necessary-false-positive', () => CheckIcon)
    .with('no-fix-necessary-wont-fix', () => CheckIcon)
    .with('no-fix-necessary-not-exploitable', () => ShieldCheckIcon)
    .with('error', () => XIcon)
    .with('blocked', () => ProhibitIcon)
    .with('excluded', () => MinusCircleIcon)
    .with('exploitable', () => ShieldWarningIcon)
    .exhaustive()
  return <Icon className={styles.outcomeIcon({ size, outcomeType })} weight="light" aria-hidden="true" />
}
